// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--12Cxt","containerBody":"containerBody--3r_vo","searchContent":"searchContent--3JoXI"};